let counterPress = 2;

const pressShowBtn = document.querySelector('.js-press-show');

if (pressShowBtn) {
    pressShowBtn.addEventListener('click', (event) => {
        event.preventDefault();
        let element = event.target;

        if (element.closest('.js-press-show')) {
            pressShowBtn.setAttribute('disabled', 'disabled');
            $.ajax({
                url: `${location.pathname}?page=${counterPress}`,
                method: 'get',
            }).done(res => {
                if (res.items_html) {
                    $('.press__wrapper').append(res.items_html);
                }
                counterPress++;
                if (!res.has_next) {
                    pressShowBtn.classList.add('press__button-more--none')
                }
            }).always(() => {
                pressShowBtn.removeAttribute('disabled');
            });
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    const mediaQuerySlider = window.matchMedia("(max-width: 768px)");
    const mediaQueryOfficesSlider = window.matchMedia("(max-width: 650px)");
    const $preloader = document.querySelector(".js-preloader");

    let hidePreloader = () => {
        setTimeout(function () {
            $preloader.classList.add("hide");
        }, 600);
    };

    let checkVideoLength = () => {
        if ($preloader) {
            let intervalId = setInterval(function () {
                if (!$(".common__video").length) {
                    hidePreloader();
                    clearInterval(intervalId);
                }
            }, 100);
        }
    };

    const $filterList = $(".js-show-list-main");
    const $showMoreInside = $(".js-show-more-inside");

    const $dropBtn = document.querySelectorAll(".js-drop-btn");

    checkVideoLength();

    if ($dropBtn) {
        $dropBtn.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.currentTarget.classList.toggle("active");
            });
        });
    }

    function reveal() {
        var reveals = document.querySelectorAll(".animate__block");

        const scrollHeight = window.scrollY;

        if (scrollHeight > 0) {
            document.querySelector(".js-header").classList.add("fixed");
            $(`.js-animate`).removeClass("animate");
        } else {
            document.querySelector(".js-header").classList.remove("fixed");
            $(`.js-animate`).addClass("animate");
        }

        if (scrollHeight > window.innerHeight) {
            document.querySelector(".js-btn-up") && document.querySelector(".js-btn-up").classList.add("active");
        } else {
            document.querySelector(".js-btn-up") && document.querySelector(".js-btn-up").classList.remove("active");
        }

        for (var i = 0; i < reveals.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = 70;

            if (elementTop < windowHeight - elementVisible) {
                reveals[i].classList.add("animate__active");
            } else {
                reveals[i].classList.remove("animate__active");
            }
        }
    }

    const $backBtn = $('.js-close-modal-case');

    if ($backBtn) {
        $backBtn.on('click', function () {
            history.back()
        })
    }

    const scrollHeight = $(window).scrollTop();

    if (scrollHeight > 100 && $(".js-header")) {
        $(".js-header").addClass("fixed");
    }

    setTimeout(() => {
        $(".modal").addClass("visible");
    }, 1000);

    window.addEventListener("scroll", reveal);
    window.addEventListener("load", reveal);

    var $anchors = document.querySelectorAll(".js-anchors");

    if ($anchors) {
        $anchors.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                const link = e.currentTarget.getAttribute("href").slice(1);

                e.currentTarget.classList.remove("open");

                if (document.querySelector(".js-menu")) {
                    $(".js-btn-menu").removeClass("open");
                    document.querySelector(".js-menu").classList.remove("active");
                    $("body").removeClass("overflow");
                }

                if (link === "casess") {
                    window.scrollTo({
                        top:
                            document.querySelector(`#element`).offsetTop +
                            document.querySelector(`#${link}`).offsetTop -
                            150,
                        behavior: "smooth",
                    });
                } else {
                    window.scrollTo({
                        top: document.querySelector(`#${link}`).offsetTop - 50,
                        behavior: "smooth",
                    });
                }
            });
        });
    }

    const $btnMenu = document.querySelector(".js-btn-menu");

    if ($btnMenu) {
        $btnMenu.addEventListener("click", (e) => {
            if (!$btnMenu.classList.contains("open")) {
                e.currentTarget.classList.add("open");
                document.querySelector(".js-menu").classList.add("active");
                document.querySelector("body").classList.add("overflow");
            } else {
                e.currentTarget.classList.remove("open");
                document.querySelector(".js-menu").classList.remove("active");
                document.querySelector("body").classList.remove("overflow");
            }
        });
    }

    const $btnCloseModal = document.querySelectorAll(".js-close-modal");

    if ($btnCloseModal) {
        $btnCloseModal.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.currentTarget.closest(".modal").classList.remove("active");
                document.querySelector("body").classList.remove("overflow");

                if (document.querySelector(".js-modal-video")) {
                    document.querySelector(".modal__video").muted = true;
                    document.querySelector(".modal__video").pause();
                    document.querySelector(".modal__video").currentTime = 0;
                }
            });
        });
    }

    const $btnCloseModalShort = document.querySelectorAll(
        ".js-close-modal-short"
    );

    if ($btnCloseModalShort) {
        $btnCloseModalShort.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.currentTarget.closest(".js-short-form-modal").classList.remove("active");

                setTimeout(() => {
                    document
                        .querySelector(".js-short-form-modal")
                        .classList.remove("transition");
                }, 200);
                setTimeout(() => {
                    document.querySelector(".js-short-form-modal").classList.remove("over");
                }, 300);

                document.querySelector("body").classList.remove("overflow");
            });
        });
    }

    const $btnModal = document.querySelectorAll(".js-btn-modal");

    if ($btnModal) {
        $btnModal.forEach((item) => {
            item.addEventListener("click", (e) => {
                document.querySelector(".js-modal").classList.add("active");
                document.querySelector("body").classList.add("overflow");
                document.getElementById("field_click_from").value = item.value;
            });
        });
    }

    const $btnModalShort = document.querySelectorAll(".js-btn-modal-short");

    if ($btnModalShort) {
        $btnModalShort.forEach((item) => {
            item.addEventListener("click", (e) => {
                document.querySelector(".js-short-form-modal").classList.add("over");
                setTimeout(() => {
                    document.querySelector(".js-short-form-modal").classList.add("transition");
                }, 5);
                setTimeout(() => {
                    document.querySelector(".js-short-form-modal").classList.add("active");
                }, 15);
                document.querySelector("body").classList.add("overflow");
                document.getElementById("field_click_from").value = item.value;
            });
        });
    }

    const $modal = document.querySelectorAll(".modal");

    document.addEventListener("keydown", function (e) {
        if (e.keyCode == 27) {
            $modal.forEach((item) => {
                item.classList.remove("active");
                document.querySelector("body").classList.remove("overflow");
                if (document.querySelector(".js-modal-video")) {
                    document.querySelector(".modal__video").muted = true;
                    document.querySelector(".modal__video").pause();
                    document.querySelector(".modal__video").currentTime = 0;
                }
            });
        }
    });

    document.addEventListener("keydown", function (e) {
        const $modalShort = document.querySelector(".js-short-form-modal");

        if (e.keyCode == 27) {
            $modalShort.classList.remove("active");

            setTimeout(() => {
                $modalShort.classList.remove("transition");
            }, 100);
            setTimeout(() => {
                $modalShort.classList.remove("over");
            }, 200);

            document.querySelector("body").classList.remove("overflow");

            if (document.querySelector(".js-modal-video")) {
                document.querySelector(".modal__video").muted = true;
                document.querySelector(".modal__video").pause();
                document.querySelector(".modal__video").currentTime = 0;
            }
        }
    });

    $(".modal").mouseup(function (e) {
        // событие клика по веб-документу
        var div = $(".modal__inner"); // тут указываем ID элемента
        if (
            !div.is(e.target) && // если клик был не по нашему блоку
            div.has(e.target).length === 0
        ) {
            // и не по его дочерним элементам
            $modal.forEach((item) => {
                item.classList.remove("active");
                document.querySelector("body").classList.remove("overflow");
            });
        }
    });

    $(".js-short-form-modal").mouseup(function (e) {
        // событие клика по веб-документу
        var div = $(".common__inner"); // тут указываем ID элемента
        if (
            !div.is(e.target) && // если клик был не по нашему блоку
            div.has(e.target).length === 0
        ) {
            // и не по его дочерним элементам
            $(".js-short-form-modal").removeClass("active");

            setTimeout(() => {
                $(".js-short-form-modal").removeClass("transition");
            }, 100);
            setTimeout(() => {
                $(".js-short-form-modal").removeClass("over");
            }, 200);

            $("body").removeClass("overflow");
        }
    });

    const $btnModalVideo = document.querySelector(".js-btn-modal-video");

    if ($btnModalVideo) {
        $btnModalVideo.addEventListener("click", (e) => {
            document.querySelector(".js-modal-video").classList.add("active");
            document.querySelector(".modal__video").play();
            document.querySelector("body").classList.add("overflow");
        });
    }

    var vid = document.querySelector(".common__video");

    if (vid) {
        var wrapper = document.querySelector(".js-current-color");
        var canvas = document.querySelector(".main__banner-fake");
        var ctx = canvas.getContext("2d");

        var ratio = window.devicePixelRatio || 1;
        var vidWidth;
        var vidHeight;

        vid.addEventListener("loadedmetadata", function (e) {
            // console.log("onloadedmetadata");
            vid.style.transform = `scale(${ratio})`;

            vidWidth = vid.videoWidth;
            vidHeight = vid.videoHeight;

            canvas.width = vid.offsetWidth * ratio;
            canvas.height = vid.offsetHeight * ratio;

            canvas.style.width = vid.offsetWidth + "px";
            canvas.style.height = vid.offsetHeight + "px";

            drawingLoop();

            //resize scale for comparison
            vid.style.transform = `scale(.7)`;

            if ($preloader) {
                hidePreloader();
            }
        });

        vid.addEventListener("loadeddata", function (e) {
            // console.log("onloadeddata");
            setVideoBgColor(vid, wrapper);
            vid.play();
        });

        function drawingLoop() {
            window.requestAnimationFrame(drawingLoop);

            ctx.drawImage(
                vid,
                0,
                0,
                vidWidth,
                vidHeight, // source rectangle
                0,
                0,
                canvas.width,
                canvas.height
            ); // destination rectangle);
        }

        function setVideoBgColor(vid, backgroundElement) {
            var canvas = document.createElement("canvas");
            canvas.width = 8;
            canvas.height = 8;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(vid, 0, 0, 8, 8);

            var p = ctx.getImageData(0, 0, 8, 8).data;
            //dont take the first but fourth pixel [r g b]
            backgroundElement.style.backgroundColor =
                "rgb(" + p[60] + "," + p[61] + "," + p[62] + ")";
        }

        window.onresize = function (event) {
            vid.style.transform = `scale(.7)`;

            vidWidth = vid.videoWidth;
            vidHeight = vid.videoHeight;

            canvas.width = vid.offsetWidth * ratio;
            canvas.height = vid.offsetHeight * ratio;

            canvas.style.width = vid.offsetWidth + "px";
            canvas.style.height = vid.offsetHeight + "px";

            ctx.drawImage(
                vid,
                0,
                0,
                vidWidth,
                vidHeight,
                0,
                0,
                canvas.width,
                canvas.height
            );

            vid.style.transform = `scale(.7)`;
        };

        vid.src = vid.dataset.src;
        vid.play();

        (function () {
            var fixAutoPlay = function (e) {
                document.removeEventListener("touchstart", fixAutoPlay);
                document.removeEventListener("touchend", fixAutoPlay);
                document.removeEventListener("scroll", fixAutoPlay);
            };
            document.addEventListener("touchstart", fixAutoPlay);
            document.addEventListener("touchend", fixAutoPlay);
            document.addEventListener("scroll", fixAutoPlay);
        })();
    }

    const allBtnSubmitForm = document.querySelectorAll('button[type="submit"]');

    const disableBtnSubmit = (btn) => {
        btn.disabled = true;
    };

    const activateBtnSubmit = (btn) => {
        btn.removeAttribute("disabled");
    };

    allBtnSubmitForm.forEach(item => {
        disableBtnSubmit(item);
    });

    const validate = (element) => {
        const $formValidate = element.closest(".js-form");

        const $formInputReq = $formValidate.querySelectorAll(
            "input[required], textarea[required]"
        );

        const btnSubmitForm = $formValidate.querySelector('button[type="submit"');

        $formInputReq.forEach((item) => {
            if (item.getAttribute("type") !== "checkbox" && item.value == "") {
                item.closest(".js-form-item").classList.remove("error-tooltip");
                item.closest(".js-form-item").classList.add("error-item");
            }

            if (item.getAttribute("type") !== "checkbox" && item.value !== "" && !item.closest(".error-tooltip")) {
                item.closest(".js-form-item").classList.remove("error-item");
            }

            if (item.getAttribute("type") == "checkbox" && !item.checked) {
                item.closest(".js-form-item").classList.add("error-item");
            }

            if (item.getAttribute("type") == "checkbox" && item.checked) {
                item.closest(".js-form-item").classList.remove("error-item");
            }
        });

        if ($formValidate.querySelector("#id_other_field_value")) {
            if (
                $formValidate
                    .querySelector("#id_other_field_value")
                    .getAttribute("required") &&
                $formValidate.querySelector("#id_other_field_value").value == ""
            ) {
                return;
            } else {
                const filterArr = [
                    ...$formValidate
                        .querySelector(".js-form-goals")
                        .querySelectorAll(".form__check-hidden"),
                ].filter((item) => item.checked);
                filterArr.length
                    ? $formValidate
                        .querySelector(".js-form-goals")
                        .classList.remove("error-item")
                    : $formValidate
                        .querySelector(".js-form-goals")
                        .classList.add("error-item");
            }
        }

        const $formCheckReq = $formValidate.querySelector("#id_i_agree");
        const $formGoalReq = $formValidate.querySelectorAll(
            ".form__check-hidden"
        );

        let checkAgreeArray = [];
        let checkGoalArray = [];
        let inputReqArray = [];

        $formInputReq.forEach(function (item) {
            if (item.getAttribute("name") !== "phone_number") {
                if (!item.value) {
                    inputReqArray.push(item);
                }
            }
        });

        if (!$formCheckReq.checked) {
            checkAgreeArray.push($formCheckReq);
        }

        if ($formGoalReq.length > 0) {
            $formGoalReq.forEach(function (item) {
                if (item.value !== "OTHER") {
                    if (
                        item.checked &&
                        !$formValidate.querySelector('[value="OTHER"]').checked
                    ) {
                        checkGoalArray.push(item);
                    } else if (
                        item.ckecked &&
                        $formValidate.querySelector('[name="OTHER"]').ckecked
                    ) {
                        if (
                            $formValidate.querySelector("#id_other_field_value").value
                                .length > 0
                        ) {
                            checkGoalArray.push(item);
                        }
                    }
                } else {
                    if (
                        item.checked &&
                        $formValidate.querySelector("#id_other_field_value").value
                            .length > 0
                    ) {
                        checkGoalArray.push(item);
                    }
                }
            });
        }

        if ($formGoalReq.length > 0) {
            if (
                checkAgreeArray.length < 1 &&
                !inputReqArray.length &&
                checkGoalArray.length > 0
            ) {
                activateBtnSubmit(btnSubmitForm);
            } else {
                disableBtnSubmit(btnSubmitForm);
            }
        } else {
            if (checkAgreeArray.length < 1 && !inputReqArray.length) {
                activateBtnSubmit(btnSubmitForm);
            } else {
                disableBtnSubmit(btnSubmitForm);
            }
        }
    };

    const $otherGoalCheckbox = $('[name="goal"][value="OTHER"]');
    const $otherGoalValueInput = $('input[name="other_field_value"]');

    $otherGoalCheckbox.change((e) => {
        if ($otherGoalCheckbox.is(":checked")) {
            $otherGoalValueInput.removeAttr("disabled");
            $otherGoalValueInput.attr("required", true);
            $otherGoalValueInput.closest("div").show();
        } else {
            $otherGoalValueInput.attr("disabled", "disabled").val("");
            $otherGoalValueInput.attr("required", false);
            $otherGoalValueInput.closest("div").hide();
        }

        validate(e.currentTarget);
    });

    $("[required]").on("blur", (e) => {
        validate(e.currentTarget);
    });

    document.querySelectorAll("#id_i_agree").forEach((item) => {
        item.addEventListener("change", (e) => {
            validate(e.currentTarget);
        });
    });

    $(".form__check-hidden").on("change", (e) => {
        validate(e.currentTarget);
    });

    $("#id_other_field_value").on("blur", (e) => {
        validate(e.currentTarget);
    });

    document.querySelectorAll("#id_other_field_value").forEach((item) => {
        item.addEventListener("change", (e) => {
            validate(e.currentTarget);
        });
    });

    const $btnUp = $(".js-btn-up");

    if ($btnUp) {
        $btnUp.on("click", function () {
            $(window).scrollTop(0);

            if ($(window).width() < 768) {
                $btnUp.addClass("active");

                setTimeout(function () {
                    $btnUp.removeClass("active");
                }, 500);
            }
        });
    }

    const $btnShowMore = $(".js-show-more");

    if ($btnShowMore) {
        $btnShowMore.on("click", function () {
            $(this).addClass("active");
            $(this).prev(".js-show-list").addClass("active");
        });
    }

    const filterButton = $(".js-button-filter");
    const cases = $("[data-filter]");

    let filterCases = (filter) => {
        cases.each(function () {
            $(this).removeAttr("style");
            $(this).data("filter") === filter
                ? $(this).addClass("active")
                : $(this).removeClass("active");
        });

        if (mediaQueryOfficesSlider.matches) {
            $filterList.find(".active").each(function (index) {
                index > 2 && $(this).hide();
            });

            $showMoreInside.removeClass("active");
        } else {
            $filterList.removeAttr("style");
        }
    };

    window.filterCases = filterCases;

    if (filterButton) {
        filterCases("cpa");

        filterButton.on("click", function () {
            filterButton.removeClass("active");
            $(this).addClass("active");
            filterCases($(this).data("filter-button"));
        });
    }

    if ($filterList && mediaQuerySlider.matches) {
        $filterList.find(".active").each(function (index) {
            index > 2 && $(this).hide();
        });

        $showMoreInside.on("click", function () {
            $filterList.find(".active").show();
            $(this).addClass("active");
        });
    }

    $(window).on("resize", function () {
        window.filterCases($(".js-button-filter.active").data("filter-button"));
    });

});